import React from 'react';
import squareDismissImage from './squareDismiss.svg';

export const SquareDismissIcon = ({ i18n }) => (<img
  src={squareDismissImage}
  alt={i18n.getString(_TL_('Square Dismiss Icon'))}
  width="20"
  height="20"
/>);
